<template>
  <card class="card-subcategories card-plain">
    <div class="card col-md-10 card-style">
      <div class="card-style container">
        <br />
        <div class="row no-gutters">
          <div class="col-md-12 align-center">
            <h3 class="ultra-bold">AGATRS Order #{{ $route.params.id }}</h3>
          </div>
        </div>
        <div class="row">
      <div class="three-sections">
  <!-- Left section (6/12) -->
  <div class="left-section">
    <div  class="row">
      <div  class="col-12 col-md-4">
        <label for="assignedToLogistic">Assigned to Logistic:</label>
      </div>
      <div  class="col-12 col-md-8">
        <logistics-user-select :is-read-only="isReadOnly"></logistics-user-select>
      </div>

      <div class="col-12 col-md-4">
        <label for="assignedToFinance">Assigned to Finance:</label>
      </div>
      <div class="col-12 col-md-8">
        <finance-user-select :is-read-only="isReadOnly"></finance-user-select>
      </div>

      <div class="col-12 col-md-4">
        <label for="assignedToPN">Assigned to Partner Nation:</label>
      </div>
      <div class="col-12 col-md-8">
        <partner-user-select 
          :countryId="agreementInfoSelectedCountryId" 
          :is-read-only="isReadOnly"
          :isPartnerAccount="isPartnerAccount">
        </partner-user-select>
      </div>
    </div>
  </div>

  <!-- Middle section (3/12) -->
  <div class="middle-section">
    <div class="mb-2">
      <label v-if="orderMetadata.requisitionNumber">
        Requisition Number: {{ orderMetadata.requisitionNumber }}
      </label>
      <label v-else>Requisition Number:</label>
    </div>

    <div class="mb-2">
      <label>Order Status: {{ orderStatusMessage }}</label>
    </div>

    <div class="mb-2">
      <label>Method of Payment: {{ methodOfPayment }}</label>
    </div>

    <div class="mb-2">
      <label>Type of Transaction: {{ typeOfTransaction }}</label>
    </div>

    <div v-if="preOrder.isRatified && !isPartnerAccount" class="mb-2">
      <label>Ratification Required?: {{ preOrder.isRatified ? 'Yes' : 'No' }}</label>
    </div>
  </div>

  <!-- Right section (3/12) -->
  <div class="right-section">
    <div class="mb-2" style="white-space:nowrap;">
      <label v-if="orderMetadata.createDate">
        Created On: {{ localtimeZone(orderMetadata.createDate) }}
      </label>
      <label v-else>Created On:</label>
    </div>

    <div class="mb-2">
      <label>Created By: {{ orderMetadata.creatorUserName }}</label>
    </div>

    <div>
      <label>LSSS Type: {{ lssType }}</label><br>
      <label>Total: {{ totalOrderAmount }}</label><br>
      <label v-if="showBalanceDue">Balance Due: {{ balanceDue }}</label>
    </div>
  </div>
</div>


        </div>
      </div>
      <div class="row">
        <div class="col-md-12 align-right">
          <!-- <change-order-status v-if="!isPartnerAccount" :is-read-only="isReadOnly" /> -->

          <button :disabled="!isOrderIdGenerated" class="btn btn-dark" @click="generateReport()">
            <i class="tim-icons icon-single-copy-04"></i> Generate Form
          </button>

          <button v-if="!isViewOnly && !isPartnerAccount && this.$route.params.id > 0" @click="duplicateOrderAsDraft" class="btn btn-warning">
            <i class="tim-icons icon-single-copy-04"></i> Duplicate Transaction
          </button>

          <duplicate-order-modal v-bind:show-duplicate-order-modal="showDuplicateOrderModal"
            v-bind:orderId="this.$route.params.id" v-on:modal-closed="clearModalData">
          </duplicate-order-modal>

          <button v-if="isDraftStatus && !isReadOnly && !isPartnerAccount && this.$route.params.id > 0 && orderMetadata.orderId > 0" @click="deleteOrder()"
            class="btn btn-danger">
            <i class="tim-icons icon-simple-remove"></i> Delete Order
          </button>
        </div>
      </div>
    </div>

    <tabs v-if="isPartnerAccount" ref="tabs" :activeTab="activeTab" :value="activeTab"
      v-on:activeTabUpdated="updateActiveTab" type="primary" tabContentClasses="tab-subcategories" square centered>
      <tab-pane v-for="item in subPagesForPartnerAccount" :id="item.id" :label="item.label" :key="item.id">
        <span slot="label">
          <i :class="['tim-icons', item.icon]"></i>{{ item.text }}
        </span>
        <MyOrder v-if="item.text === 'My Order'" :is-read-only="isReadOnly" v-on:show-document-tab="switchToDocument">
        </MyOrder>
        <Remarks v-bind:isPartnerAccount="isPartnerAccount" v-if="item.text === 'Remarks'" :is-read-only="isReadOnly">
        </Remarks>
        <Attachments v-bind:isPartnerAccount="isPartnerAccount" v-if="item.text === 'Attachments'"
          :is-read-only="isReadOnly"></Attachments>
      </tab-pane>
    </tabs>
    <tabs v-else ref="tabs" :activeTab="activeTab" :value="activeTab" v-on:activeTabUpdated="updateActiveTab"
      type="primary" tabContentClasses="tab-subcategories" square centered>
      <tab-pane v-for="item in subPages" :id="item.id" :label="item.label" :key="item.id">
        <span slot="label">
          <i :class="['tim-icons', item.icon]"></i>{{ item.text }}
        </span>
        <MyOrder v-if="item.text === 'My Order'" :is-read-only="isReadOnly" v-on:show-document-tab="switchToDocument">
        </MyOrder>
        <Documents v-if="item.text === 'Documents'" :is-read-only="isReadOnly"></Documents>
        <Remarks v-bind:isPartnerAccount="isPartnerAccount" v-if="item.text === 'Remarks'" :is-read-only="isReadOnly">
        </Remarks>
        <Attachments v-bind:isPartnerAccount="isPartnerAccount" v-if="item.text === 'Attachments'"
          :is-read-only="false"></Attachments>
        <AuditLog v-if="item.text === 'Audit Log'" :is-read-only="isReadOnly"></AuditLog>
      </tab-pane>
    </tabs>
  </card>
</template>

<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import { Select, Option, Alert, Tag } from "element-ui";
import MyOrder from "@/components/App/order/subpages/MyOrder.vue";
import Documents from "@/components/App/order/subpages/Documents.vue";
import Attachments from "@/components/App/order/subpages/Attachments.vue";
import Remarks from "@/components/App/order/subpages/Remarks.vue";
import AuditLog from "@/components/App/order/subpages/AuditLog.vue";
import LogisticsUserSelect from "@/components/App/order/user/LogisticsUserSelect";
import FinanceUserSelect from "@/components/App/order/user/FinanceUserSelect";
import PartnerUserSelect from "@/components/App/order/user/PartnerUserSelect";
import ChangeOrderStatus from "@/components/App/order/status/changeorderstatus";
import swal from "sweetalert2";
import { Tabs, TabPane } from "@/components";
import Util from "@/util/util";
import Utility from "@/mixins/utility/utility";
import DuplicateOrderModal from "../components/App/order/DuplicateOrderModal.vue";

export default {
  name: "Order",
  mixins: [Utility],
  data() {
    return {
      showDuplicateOrderModal: false,
      lineItemTotal: "N/A",
      activeTab: "",
      subPagesForPartnerAccount: [
        {
          id: 1,
          text: "My Order",
          label: "MyOrder",
          icon: "icon-app",
        },
        {
          id: 2,
          text: "Remarks",
          label: "Remarks",
          icon: "icon-notes",
        },
        {
          id: 4,
          text: "Attachments",
          label: "Attachments",
          icon: "icon-attach-87",
        },
      ],
      subPages: [
        {
          id: 1,
          text: "My Order",
          label: "MyOrder",
          icon: "icon-app",
        },
        {
          id: 2,
          text: "Documents",
          label: "Documents",
          icon: "icon-single-copy-04",
        },
        {
          id: 3,
          text: "Remarks",
          label: "Remarks",
          icon: "icon-notes",
        },
        {
          id: 4,
          text: "Audit Log",
          label: "AuditLog",
          icon: "icon-paper",
        },
      ],
    };
  },
  components: {
    Tabs,
    TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    MyOrder,
    Documents,
    Attachments,
    Remarks,
    AuditLog,
    LogisticsUserSelect,
    FinanceUserSelect,
    PartnerUserSelect,
    ChangeOrderStatus,
    DuplicateOrderModal,
  },
  async mounted() {
    await this.loadAgreementInformation(this.$route.params.id);
    await this.getInspectedReceivedByStatus(this.$route.params.id);
  },
  async created() {
    this.$store.dispatch("clearAllOrderData"); // clear all order data
    if (this.$route.params.id > 0) {
      await this.getOrderByStatus({
        orderStatus: this.orderMetadata.orderStatus,
        id: this.$route.params.id,
      });
    } else {
      this.clearOrder();
    }

    this.getLogisticsUsers(false);
    this.getFinanceUsers(false);
    this.$store.dispatch("users/getUserByEmail");

    if (this.$route.params.id > 0) {
      this.getOrderMetadata(this.$route.params.id).then(() => {
        if (this.isOrderComplete) {
          this.$router.push({
            name: "ViewOrder",
            params: this.$route.params.id,
          });
        }
      this.getLineItems(this.$route.params.id);
      this.handleLineItemTotal();
      this.loadAllDisbursingInfoByOrderId(this.$route.params.id);
      this.getDisbursingCollectionOutstandingBalance(this.$route.params.id);

      });

      //await this.searchByOrderId();
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
      isSuperAdmin: "authentication/isSuperAdmin",
      isPNManager: "authentication/isPNManager",
      countryUpdated: "implementArrangment/countryUpdated",
      orderMetadata: "orderMetadata/orderMetadata",
      agreementInfoSelectedCountryId:
        "agreementInformation/agreementInfoSelectedCountryId",
      lineItems: "lineItem/lineItems",
      isOrderViewOnly: "orderMetadata/isOrderViewOnly",
      user: "users/user",
      financeUserId: "orderMetadata/financeUserId",
      authenticatedUser: "users/authenticatedUser",
      preOrder: "preOrderDetail/preOrder",
      logisticsUserId: "orderMetadata/logisticsUserId",
      order: "orders/order",
      draftOrders: "orders/draftOrders",
      activeOrders: "orders/activeOrders",
      completedOrders: "orders/completedOrders",
      userCanEdit: "orderUsers/canUserEditOrder",
      documents: "documents/getDocuments",
      isPartnerAccount: "authentication/isPartnerAccount",
      disbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/disbursingCollectionOutstandingBalance",
      disbursingCollections:
        "disbursingCollectionInformation/disbursingCollections",
        returnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentStatus",
        inspectedReceivedByStatus: "inspectedReceivedBy/inspectedReceivedByStatus",
        isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
    }),
    isCompletionDocumentUploaded() {
      const relevantDocuments = [
        Util.TRANSACTION_COMPLETED,
        Util.TRANSACTION_COMPLETION,
      ];
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.some((fileType) =>
            relevantDocuments.includes(fileType)
          )
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded ? true : false;
    },

    showBalanceDue() {
      return this.orderMetadata.orderStatus === "DRAFT" || this.orderMetadata.orderStatus === "SUBMITTED" || this.orderMetadata.orderStatus === "AUTHORIZED"
        ? false
        : true;
    },
    balanceDue() {
      if (this.disbursingCollectionOutstandingBalance) {
        return Util.inMoneyFormatWithDollarSign(this.disbursingCollectionOutstandingBalance);
      } else {
        return Util.inMoneyFormatWithDollarSign(0);
      }
    },
    currentOrderId() {
      return this.$route.params.id;
    },
    totalOrderAmount() {
      return this.order ? this.order.totalLabel : "N/A";
    },
    methodOfPayment() {
      return this.order ? this.order.paymentMethod : "N/A";
    },
    typeOfTransaction() {
      return this.order ? this.order.usBuySell : "N/A";
    },
    lssType() {
      return this.order ? this.order.lssType : "N/A";
    },
    canDuplicateTransaction() {
      return this.user.id == this.orderMetadata.financeUserId ||
        this.user.id == this.orderMetadata.logisticsUserId
        ? true
        : false;
    },
    isDraftStatus() {
      return this.orderMetadata.orderStatus === "DRAFT";
    },
    isOrderIdGenerated() {
      if (this.orderMetadata !== undefined)
        return this.orderMetadata.orderId.toString() !== "0";
      return false;
    },
    isReadOnly() {
      return this.$route.fullPath
        .toLowerCase()
        .includes(`/view/${this.$route.params.id}`) && this.isOrderViewOnly
        ? true
        : false;
    },
    isViewOnly() {
      return window.location.href.includes(`order/view/`);
    },
    orderStatus() {
      if (this.orderMetadata) {
        return this.orderMetadata.orderStatus == "COMPLETED"
          ? "success"
          : "danger";
      }
    },
    orderStatusMessage() {
      if (this.orderMetadata) {
        return `${this.orderMetadata.orderStatus}`;
      }
    },
    isOrderComplete() {
      return this.orderMetadata.orderStatus === "COMPLETED";
    },
  },
  methods: {
    ...mapActions({
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      getLogisticsUsers: "users/getLogisticsUsers",
      getPartnerNationUsers: "users/getPartnerNationUsers",
      getFinanceUsers: "users/getFinanceUsers",
      getLineItems: "lineItem/getLineItems",
      //setSearchCriteria: "orders/setSearchCriteria",
      clearSearchCriteria: "orders/clearSearchCriteria",
      //getSearchResults: "orders/getSearchResults",
      clearSearchResults: "orders/clearSearchResults",
      getOrderByStatus: "orders/getOrderByStatus",
      clearOrder: "orders/clearOrder",
      getDisbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalance",
      getDisbursingCollectionOutstandingBalanceWithoutFormat: "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalanceWithoutFormat",
      loadAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/loadAllDisbursingInfoByOrderId",
      loadAgreementInformation: "agreementInformation/loadAgreementInformation",
      getInspectedReceivedByStatus: "inspectedReceivedBy/getInspectedReceivedByStatus",
    }),
    handleLineItemTotal() {
      try {
        this.lineItemTotal =
          "$" + Util.numberWithCommas(this.searchResults.results[0].total);
      } catch {
        this.lineItemTotal = "N/A";
      }
    },
    updateActiveTab(tab) {
      this.activeTab = tab;
    },
    generateAcsa() {
      this.$router.push(`/GenerateAcsaPage/${this.$route.params.id}`);
    },
    switchToDocument() {
      this.activeTab = "Documents";
      this.$refs.tabs.findAndActivateTab("Documents");
    },
    generateReport() {
      this.$router.push({
        name: "Order13A",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    duplicateOrderAsDraft() {
      this.showDuplicateOrderModal = true;
    },
    clearModalData(retData) {
      this.showDuplicateOrderModal = false;
      // close modal then push to dashboard, scrollbar won't bug out
      if (retData.hasDuplicated) {
        new swal({
          title: "Order Duplicated",
          text: `Order Successfully Duplicated as Draft Order #${retData.orderId}. This order can be viewed and edited in the "Draft" tab`,
          icon: "success",
          confirmButtonColor: "#10b45a",
        }).then((d) => {
          if (d.value && retData.hasDuplicated) {
            this.$router.push("/Dashboard?currentTab=draft");
          }
        });
      }
    },
    deleteOrder() {
      Util.swalConfirmation(
        "warning",
        `Do you want to delete Order #${this.$route.params.id}?`,
        "Delete Confirmation",
        `Delete Order #${this.$route.params.id}!`,
        true
      ).then((result) => {
        if (result.value) {
          axios
            .delete(`api/orders/${this.$route.params.id}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: "Your order has been deleted successfully.",
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
              this.$router.push("/Dashboard");
            });
        }
      });
    },
    localtimeZone(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
  },
};
</script>

<style scoped>
.card-style {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}

.tab-content.tab-subcategories {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.more-width {
  width: 28%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.order-status {
  margin-top: 5px;
  margin-bottom: 5px;
}

/* Change Duplicate Transaction and other btn-warning buttons to be darker orange for 508 compliance */

.btn-warning {
  background-image: none !important;
  background-color: #d5440f;
}

@media (max-width: 1300px) {
  .col-md-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 100%;
    max-width: 80%;
  }
}

.auto {
  margin: auto;
}

.hide {
  border-right: 1px solid #d3d3d3;

  @media only screen and (max-width: 1026px) {
    border-right: none;
  }
}




.three-sections {
  display: flex;
  flex-wrap: wrap;
  gap: 15px; /* spacing between sections */
}

.left-section {
  flex: 0 0 50%; /* takes 6/12 of space */
}


@media (max-width: 1240px) {
  .left-section {
    flex: 0 0 100%; /* full width */
  }
}

.middle-section {
  flex: 0 0 22%; /* takes 3/12 of space */
  justify-content: end;
}

.right-section {
  flex: 0 0 23%; /* takes 3/12 of space */
}


</style>